import React from 'react';
import { graphql } from 'gatsby';
import { ReportsFeed as ReportsFeedComponent } from '../../ReportsFeed';

export const ReportsFeed = ({ data, ...rest }) => <ReportsFeedComponent {...data} {...rest} />;

export const ReportsFeedQuery = graphql`
  fragment ReportsFeed on KFH_UmbracoReportsFeedComponentType {
    title
    backgroundColour
    marketReports {
      relativeUrl
      layout {
        ... on KFH_ContentMarketReportType {
          title
          year
          season
          coverImage {
            localFile {
              gatsbyImage(
                width: 452
                height: 340
                layout: CONSTRAINED
                placeholder: NONE
                quality: 80
                backgroundColor: "#F5F5F5"
              )
            }
            altText
          }
        }
      }
    }
  }
`;
